import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate } from '../../../../utils/util';
import BackButton from '../../../../components/UI/BackButton';
import ListInventoryGeneral from './ListInventoryGeneral';
import InventoryService from '../../../../services/InventoryService';
import * as actionsInventory from '../../../../actions/inventoryAction';
import { PERMISSIONS } from '../../../../utils/constants';
import { checkPermission } from '../../../../services/auth';

const InventoryGeneralFilter = (props) => {
    const manageInventory = checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.LoadInventory : PERMISSIONS.Inventory.Rotative.LoadInventory);
    let disable = false;

    const onClickRefresh = (event) => {
        if (!disable) {
            disable = true;
            event.preventDefault();
            props.setFilterInventory(0);// Mudar pra Reset?
            setTimeout(() => { disable = false; }, 5000);
            props.refreshInventory(props.filter);
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('inventory', 'inventory')}
                    </div>
                    <div className="subtitle">
                        | <i className="mdi mdi-alpha-g-circle-outline" />
                        {props.filter.typeInventory === 'G' ? translate('menu.general', 'inventory') : translate('menu.rotative', 'inventory')}
                    </div>
                    {manageInventory && (
                        <div className="title">
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '0px', right: '45px' }}
                                onClick={(event) => { onClickRefresh(event); }}
                            ><i className="mdi mdi-cached" style={{ cursor: 'pointer' }} />
                            </span>
                        </div>
                    )}
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '40px', }}>
                <ListInventoryGeneral data={props} />
            </div>
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        refreshInventory: (filter) => {
            dispatch(InventoryService.refreshInventory(filter));
        },
        setFilterInventory: (inventory) => {
            dispatch(actionsInventory.selectInventory(inventory));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryGeneralFilter)));
